import { jsx as g } from "react/jsx-runtime";
import { forwardRef as d, useRef as f, useEffect as s } from "react";
import { bindForwardedRef as u } from "@givebutter/react-util";
import { twMerge as h } from "tailwind-merge";
const b = d(
  ({ onInput: i, className: n, autoResize: e = !1, error: l, ...o }, a) => {
    const r = f(), c = (t) => {
      i == null || i(t), r.current && e && (r.current.style.height = "auto", r.current.style.height = `${r.current.scrollHeight}px`);
    };
    return s(() => {
      !e || !r.current || r.current.value && r.current.setAttribute("style", `height: ${r.current.scrollHeight}px`);
    }, [e, r]), /* @__PURE__ */ g(
      "textarea",
      {
        ref: (t) => {
          r.current = t, u(a, t);
        },
        onInput: c,
        className: h(
          "resize-none rounded-lg border-none bg-white p-3 leading-4 outline-none ring-1 ring-inset ring-gray-300",
          //
          "focus:ring-2 focus:ring-blue-500",
          //
          "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-300 disabled:placeholder:text-gray-200",
          //
          "placeholder:text-gray-400",
          //
          l && "ring-2 ring-red-500",
          e && "overflow-y-hidden",
          n
        ),
        ...o
      }
    );
  }
), m = b;
export {
  m as Root,
  b as Textarea
};
